import { Simulation } from 'src/app/core/models/simulation.model';
import { Color, Line } from 'three';
import { Catenary3D } from '../../catenary-answer';
import { Line as SimulationLine } from '../../line.model';
import { LineBuilder } from '../object-builders/line-builder.model';
import GraphicProperties from './graphic-properties.model';

export class LineGraphicProperties extends GraphicProperties {
  color: Color;
  width: number;

  constructor({ color = new Color(0xffffff), width = 2 } = {}) {
    super();
    this.color = color;
    this.width = width;
  }

  updateColor(color: Color): void {}

  async build(riser: Catenary3D, simulation: Simulation, line: SimulationLine): Promise<Line> {
    this.object = await this.getBuilder().build(riser, simulation, line);
    return this.object;
  }

  getBuilder(): LineBuilder {
    return new LineBuilder({
      color: this.color,
      width: this.width,
    });
  }
}
